import { Pipe, PipeTransform } from "@angular/core";
import { isPropertyDefined } from "@recursyve/nice-ts-utils";
import {
    sanitizeDirectusObject,
    sanitizeDirectusRelationArray,
    sanitizeDirectusRelationObject
} from "../../../../../../../common/utils/sanitize-directus-object";
import { ItemsProductCategories } from "../../../../../../api/packbo/models/items-product-categories";
import { ItemsSuppliers } from "../../../../../../api/packbo/models/items-suppliers";

@Pipe({
    name: "getCategory"
})
export class GetCategoryPipe implements PipeTransform {
    public transform(supplier: ItemsSuppliers): ItemsProductCategories | null {
        const itemCategories = sanitizeDirectusRelationObject(supplier, "product_categories_refs");

        const itemProductCategories = sanitizeDirectusRelationArray(itemCategories, "product_categories_id").map(
            sanitizeDirectusObject
        );

        for (const category of itemProductCategories) {
            if (!isPropertyDefined(category, "parent_ref")) {
                return category;
            } else {
                return sanitizeDirectusObject(category.parent_ref);
            }
        }

        return null;
    }
}
